<template lang="pug">
div    
    modal(v-show="isShowModal_",:titulo="'ACTUALIZACION ' + nameModulo.toUpperCase()" bindClass="col-md-4 col-sm-12" , @close="isShowModal_=false")
        div(slot='body')  
            .form-group
                .form-row
                    .col-md-12.col-sm-12
                        label Nombre de Usuario
                        input.form-control.form-control-sm(v-model="parameter.NameUser", @keypress.enter="sendInfo()") 
                .form-row
                    .col-md-12.col-sm-12
                        label Email
                        input.form-control.form-control-sm(v-model="parameter.Email", readonly)
                .form-row
                    .col-md-12.col-sm-12
                        label Cargo
                        input.form-control.form-control-sm(v-model="parameter.Position")                        
                .form-row
                    .col-md-12.col-sm-12
                        label Estado
                        select.form-control.form-control-sm(v-model="parameter.Active" )
                            option(value=1) Activa
                            option(value=0) Inactiva  
        div(slot='footer')                      
            button.btn.btn-primary(@click="sendInfo()") Guardar
                       
</template>
<script>
import modal from "../../../complementos/modal.vue"
export default {
    props:{ 
        nameModulo:String,
        IsShowModal:Boolean,
        parameter:Object
    },
    data(){
        return{ 
                TypeAccount:'' 
            }
    },
    components:{
        modal
    },
    mounted(){
        this.TypeAccount=this.$info.typeAccount
        console.log(this.$info)
    },
    computed:{
        isShowModal_ :{
                        get(){return this.IsShowModal },
                        set(val){this.$emit("update:IsShowModal",val)}
        } 
    },
    methods:{ 
            sendInfo(){
                if(this.validate()){
                    this.$emit("update:parameter",this.parameter)            
                    this.$emit("sendInfo",this.parameter)
                }         
            },
            validate(){
                if(this.parameter.IdEnterprise=='0' || this.parameter.IdEnterprise=='' || this.parameter.IdEnterprise==null ){
                    this.$msgbox.show("No Hay Empresa Selecionada o Cargada","Alerta")
                    return false
                } 
                else if(this.parameter.NameUser=='' || this.parameter.NameUser==null ){
                    this.$msgbox.show("Ingrese Nombre de Usuario","Alerta")
                    return false
                } 
                else if(this.parameter.Email=='' || this.parameter.Email==null ){
                    this.$msgbox.show("Ingrese Email","Alerta")
                    return false
                }
                else if(this.parameter.Password=='' || this.parameter.Password==null ){
                    this.$msgbox.show("Ingrese Contraseña","Alerta")
                    return false
                }
                else if(this.parameter.TypeAccount=='' || this.parameter.TypeAccount==null ){
                    this.$msgbox.show("Selecione Tipo de Cuenta","Alerta")
                    return false
                }
                else{
                    return true
                }
            }
    }

    
}
</script>